import './pagination.sass';

export { default } from './pagination';
